import React from 'react';
import {Button} from '@components';
import {Card, Form, Row, Col} from 'react-bootstrap';
import {Formik} from 'formik';
import * as yup from 'yup';
import {useSelector, useDispatch} from 'react-redux';
import {toast} from 'react-toastify';
import {
    messageError,
    messageToast,
    objectDataTypeSex,
    role,
    typeError
} from '../../utils/define';
import {updateAccountAction, reloadAccount} from '../../store/reducers/account';
import { formatDateTimeWithoutHour } from '@app/utils/helper';

const schema = yup.object().shape({
    fullName: yup.string().required(messageError.emptyMessage)
    // email: yup
    //     .string()
    //     .email(messageError.emailMessage)
    //     .required(messageError.emptyMessage)
});

const SettingsTab = ({isActive}) => {
    const itemAccount = useSelector((state) => state.account.itemAccount);
    const dispatch = useDispatch();

    const handleUpdate = async (values, actions) => {
        const modelUpdate = {
            data: values,
            id: itemAccount.id
        };

        try {
            const result = await dispatch(updateAccountAction(modelUpdate));
            if (result.payload.errors) {
                if (result.payload.type === typeError.Email) {
                    actions.setErrors({
                        email: result.payload.errors.content[0]
                    });
                }
                // toast.error(result.payload.errors.content[0]);
            }
            if (result.payload === 200) {
                await dispatch(reloadAccount(values));
                toast.success(messageToast.messageToastUpdateSuccess);
            }
        } catch (error) {
            toast.error(messageToast.messageToastTryCatch);
        }
    };

    return (
        <div className={`tab-pane ${isActive ? 'active' : ''}`}>
            <Card.Body>
                <Formik
                    enableReinitialize
                    validationSchema={schema}
                    onSubmit={(values, actions) =>
                        handleUpdate(values, actions)
                    }
                    initialValues={{
                        fullName: itemAccount ? itemAccount.fullName : '',
                        // email: itemAccount ? itemAccount.email : '',
                        roles: itemAccount ? itemAccount.roles.split(', ') : [],
                        isActive: itemAccount ? itemAccount.isActive : false,
                        birthDate:
                            itemAccount && itemAccount.accountPatientInfoResponse
                                ? formatDateTimeWithoutHour(itemAccount.accountPatientInfoResponse.birthDate)
                                : '',
                        dataTypeSex:
                            itemAccount &&
                            itemAccount.accountPatientInfoResponse &&
                            objectDataTypeSex.find(
                                (x) =>
                                    x.value ==
                                    itemAccount.accountPatientInfoResponse.dataTypeSex
                            )
                                ? objectDataTypeSex.find(
                                      (x) =>
                                          x.value ==
                                          itemAccount.accountPatientInfoResponse
                                              .dataTypeSex
                                  ).label
                                : '',
                        telephone: itemAccount
                            ? itemAccount.accountPatientInfoResponse.telephone
                            : '',
                        objectName:
                            itemAccount && itemAccount.accountPatientInfoResponse
                                ? itemAccount.accountPatientInfoResponse.objectName
                                : '',
                    }}
                >
                    {({handleSubmit, handleChange, values, errors}) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Họ tên
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control
                                        disabled
                                        type="text"
                                        placeholder="Họ tên"
                                        name="fullName"
                                        value={values.fullName}
                                        onChange={handleChange}
                                        // isInvalid={!!errors.fullName}
                                    />

                                    {/* <Form.Control.Feedback type="invalid">
                                        {errors.fullName}
                                    </Form.Control.Feedback> */}
                                </Col>
                            </Form.Group>
                            {values.roles.includes(role.Patient) ? (
                                <>
                                    <Form.Group as={Row} className="mb-3">
                                        <Form.Label className="col-sm-2 col-form-label">
                                            Ngày sinh
                                        </Form.Label>
                                        <Col sm="10">
                                            <Form.Control
                                                type="text"
                                                disabled
                                                placeholder="Ngày sinh"
                                                name="birthDate"
                                                value={values.birthDate}
                                            />
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} className="mb-3">
                                        <Form.Label className="col-sm-2 col-form-label">
                                            Giới tính
                                        </Form.Label>
                                        <Col sm="10">
                                            <Form.Control
                                                type="text"
                                                disabled
                                                placeholder="Giới tính"
                                                name="dataTypeSex"
                                                value={values.dataTypeSex}
                                            />
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} className="mb-3">
                                        <Form.Label className="col-sm-2 col-form-label">
                                            Điện thoại
                                        </Form.Label>
                                        <Col sm="10">
                                            <Form.Control
                                                type="text"
                                                disabled
                                                placeholder="Điện thoại"
                                                name="telephone"
                                                value={values.telephone}
                                            />
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} className="mb-3">
                                        <Form.Label className="col-sm-2 col-form-label">
                                            Đối tượng
                                        </Form.Label>
                                        <Col sm="10">
                                            <Form.Control
                                                type="text"
                                                disabled
                                                placeholder="Đối tượng"
                                                name="objectName"
                                                value={values.objectName}
                                            />
                                        </Col>
                                    </Form.Group>
                                </>
                            ) : (
                                <></>
                            )}

                            {values.roles.includes(role.Admin) ||
                            values.roles.includes(role.Doctor) ? (
                                <Form.Group as={Row} className="mb-3">
                                    <Col md={{span: 10, offset: 2}}>
                                        <Button type="submit" theme="danger">
                                            Cập nhật
                                        </Button>
                                    </Col>
                                </Form.Group>
                            ) : (
                                <></>
                            )}
                        </Form>
                    )}
                </Formik>
            </Card.Body>
        </div>
    );
};

export default SettingsTab;
